import React, { useCallback, useMemo, useState } from 'react'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import { Button, Modal, Space, Tag } from 'antd'
import { get, isEmpty, map, noop } from 'lodash'
import PropTypes from 'prop-types'

import { getIncludedAllergensOfId } from '../../helpers'
import { antFormItemNamePropType } from '../../prop-types'

import ListItemSelect from './list-item-select'

const AllergenFormListItem = ({
  shouldModify,
  name,
  treeData,
  onClear,
  value,
  onChange,
  allergenOptionsGroupedById,
  ...rest
}) => {
  const [isIncludedAllergensModalVisible, setIsIncludedAllergensModalVisible] =
    useState(false)

  const valueName = useMemo(
    () => get(allergenOptionsGroupedById, `${value}[0].label`),
    [allergenOptionsGroupedById, value],
  )

  const includedAllergensOfValue = useMemo(
    () => getIncludedAllergensOfId(value, allergenOptionsGroupedById),
    [allergenOptionsGroupedById, value],
  )

  const showModal = useCallback(
    () => setIsIncludedAllergensModalVisible(true),
    [],
  )

  const hideModal = useCallback(
    () => setIsIncludedAllergensModalVisible(false),
    [],
  )

  return (
    <Space>
      <ListItemSelect
        shouldModify={shouldModify}
        name={name}
        treeData={treeData}
        onClear={onClear}
        value={value}
        onChange={onChange}
        {...rest}
      />
      {!isEmpty(includedAllergensOfValue) && (
        <>
          <Button
            shape="circle"
            icon={<MenuUnfoldOutlined />}
            size="small"
            onClick={showModal}
          />
          <Modal
            visible={isIncludedAllergensModalVisible}
            title={`Included Allergens for ${valueName}`}
            footer={null}
            onCancel={hideModal}
          >
            {map(includedAllergensOfValue, ({ id }) => (
              <Tag key={id}>
                {get(allergenOptionsGroupedById, `${id}[0].label`)}
              </Tag>
            ))}
          </Modal>
        </>
      )}
    </Space>
  )
}

AllergenFormListItem.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  shouldModify: PropTypes.func.isRequired,
  name: antFormItemNamePropType.isRequired,
  treeData: PropTypes.array.isRequired,
  onClear: PropTypes.func.isRequired,
  allergenOptionsGroupedById: PropTypes.object,
}

AllergenFormListItem.defaultProps = {
  value: undefined,
  onChange: noop,
  allergenOptionsGroupedById: {},
}

export default AllergenFormListItem
